<script>
/**
 * Descripción: Pantalla Usuarios Filtro
 *
 * @displayName UserFilterViewComponent
 */

import { mapActions } from 'vuex';
import BaseArrayHelper from '@/helpers/BaseArrayHelper.js';
import httpService from '@/services/httpService.js';

const BaseServerDataTable = () =>
  import('@/components/core/grids/BaseServerDataTable.vue');

export default {
  name: 'UserFilterViewComponent',

  components: {
    BaseServerDataTable
  },

  computed: {
    /**
     * Configuracion BaseServerDataTable
     */
    setting() {
      return {
        controller: 'User',
        columns: [
          {
            text: 'Nombre',
            align: 'start',
            value: 'userName',
            show: true
          },
          {
            text: 'Usuario',
            align: 'start',
            value: 'userLogin',
            show: true
          },
          {
            text: 'Rol',
            align: 'start',
            value: 'profileName',
            show: true
          },
          {
            text: 'Activo',
            align: 'start',
            value: 'activo',
            type: 'hidden',
            show: true
          }
        ],
        key: 'userId'
      };
    }
  },

  created() {
    /**
     * Configuracion Encabezado
     */
    this.addNavbar(['Usuarios']);
  },

  methods: {
    /**
     * Configuración NavBar
     */
    ...mapActions('navbar', ['addNavbar']),

    /**
     * Crear Nuevo Usuario
     */
    $_new() {
      // object
      this.$router.push({ name: 'UserEditorViewComponent' });
    },

    /**
     * Editar Pantalla Editor
     */
    $_edit(params) {
      // object
      this.$router.push({
        name: 'UserEditorViewComponent',
        params: { Id: params.selected[this.setting.key] }
      });
    },

    /**
     * Eliminar Objecto
     */
    $_delete(params) {
      let object = BaseArrayHelper.SetObject({}, params[0]);
      httpService.post('User/Delete', [object]).then(response => {
        if (response != undefined) {
          //Logica JS luego de la acción exitosa!!!
          this.$refs.userFilter.$_ParamsToAPI();
        }
      });
    }
  }
};
</script>

<template>
  <div>
    <!-- @BaseServerDataTable -->
    <BaseServerDataTable
      ref="userFilter"
      :setting="setting"
      :fnNew="$_new"
      :fnEdit="$_edit"
      :fnDelete="$_delete"
    />
  </div>
</template>
